var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.44,
    height: 17.912,
    viewBox: "0 0 17.44 17.912",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings",
    transform: "translate(-3.619 -3.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M19.392,12.5v-.982l1.232-1.078a1.283,1.283,0,0,0,.244-1.636L19.354,6.242a1.295,1.295,0,0,0-1.52-.577l-1.559.526a7.281,7.281,0,0,0-.84-.481l-.327-1.617A1.283,1.283,0,0,0,13.824,3.06h-3A1.283,1.283,0,0,0,9.539,4.093L9.211,5.709a7.365,7.365,0,0,0-.847.481L6.838,5.639A1.283,1.283,0,0,0,6.427,5.6a1.283,1.283,0,0,0-1.11.642L3.8,8.808a1.283,1.283,0,0,0,.263,1.61l1.212,1.11v.982L4.066,13.587A1.283,1.283,0,0,0,3.8,15.223l1.514,2.566a1.295,1.295,0,0,0,1.52.577L8.4,17.84a7.281,7.281,0,0,0,.84.481l.327,1.617a1.283,1.283,0,0,0,1.283,1.033h3.028a1.283,1.283,0,0,0,1.283-1.033l.327-1.617a7.365,7.365,0,0,0,.847-.481l1.552.526a1.295,1.295,0,0,0,1.52-.577l1.463-2.566a1.283,1.283,0,0,0-.263-1.61Zm-1.148,4.645-2.2-.744a5.684,5.684,0,0,1-1.739,1.007l-.455,2.3H10.822l-.455-2.277a6,6,0,0,1-1.732-1.007l-2.207.719L4.913,14.581l1.745-1.54a5.71,5.71,0,0,1,0-2.008L4.913,9.449,6.427,6.883l2.2.744A5.684,5.684,0,0,1,10.366,6.62l.455-2.3H13.85l.455,2.277A6,6,0,0,1,16.037,7.6l2.207-.719,1.514,2.566-1.745,1.54a5.71,5.71,0,0,1,0,2.008l1.745,1.585Z",
    fill: "#6b7280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M18.849,22.7A3.849,3.849,0,1,1,22.7,18.849,3.811,3.811,0,0,1,18.849,22.7Zm0-6.415a2.508,2.508,0,1,0,1.832.734A2.508,2.508,0,0,0,18.849,16.283Z",
    transform: "translate(-6.513 -6.834)",
    fill: "#6b7280"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.2bca72112ea5b5ad03bb2db625d53d12.svg";
export { ForwardRef as ReactComponent };